import React from 'react';
import ReactPlayer from 'react-player'

const path = process.env.PUBLIC_URL

const Video = () => {
  return(
    <div className="video__wrapper" style={{ backgroundImage: 'url(' + path + '/images/imagebg.png)' }}>
    <ReactPlayer
      className="video"
      url="https://player.vimeo.com/progressive_redirect/playback/663031136/rendition/1080p/1080p.mp4?loc=external&signature=1b5fede28c35b9ce8527a924eb39c812a55d5195f4bcd09184999ac117e24807"
      width="100%"
      height="auto"
      controls={ true }
      autoPlay={ false }
      muted={ false }
      pip={ false }
      config={ { file: {
        attributes: { poster: path + '/images/video_b.jpg', preload: 'none'  }
      } } }
    />
  </div>
  )
}

export default Video